import axios from "axios";
import { encryptPayload, decryptPayload, generateDomainTrace } from "../utils/crypto";

const CONTENT_BASE_URL = "https://content-api-prd.promotionalproductsnow.au";

const API_BASEURL =
  process.env.NODE_ENV !== "production"
    ? "http://localhost:3002/api/v1"
    : "https://api-prd.promotionalproductsnow.au/api/v1";

// ──────────── Encryption Interceptors (global axios) ────────────
// These apply to all axios calls made from any API module.
// Only main API calls are encrypted; content API calls are left untouched.

axios.interceptors.request.use(
  async (config) => {
    const url = config.url || "";
    const isMainApiCall = url.startsWith(API_BASEURL);

    // Encrypt request body for main API calls (skip content API & file uploads)
    if (
      isMainApiCall &&
      config.data &&
      typeof config.data === "object" &&
      !(config.data instanceof FormData)
    ) {
      try {
        // encryptPayload returns a base64 string; wrap it so server expects { payload }
        const payload = await encryptPayload(config.data);
        config.data = { payload };

        // console.dir({ original: config.data }, { depth: null });

        config.headers["X-Encrypted"] = "true";
        config.headers["Content-Type"] = "application/json";
        // console.dir("Encrypted request payload:", config.data);
      } catch (e) {
        console.error("Failed to encrypt request:", e);
      }
    }

    // Attach encrypted domain + timestamp verification header
    if (isMainApiCall) {
      try {
        const hostname =
          typeof window !== "undefined" ? window.location.hostname : new URL(API_BASEURL).hostname;
        config.headers["x-req-trace"] = await generateDomainTrace(hostname);
      } catch (e) {
        console.error("Failed to generate domain trace:", e);
      }
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  async (response) => {
    // Decrypt encrypted responses from main API
    if (response.data?.encrypted === true && response.data?.payload) {
      try {
        response.data = await decryptPayload(response.data.payload);
      } catch (e) {
        console.error("Failed to decrypt response:", e);
      }
    }
    return response;
  },
  (error) => Promise.reject(error),
);

export { CONTENT_BASE_URL, API_BASEURL };
